import { css } from '@emotion/css';
import { usePage } from 'Shared/frontend/PageProvider';
import {Nav} from 'Shared/backend/nav/Nav';
import { borderBackgroundColour, maxBodyWidth, navHeight } from 'Shared/backend/Theme';
import { sizes } from 'Shared/backend/Theme';
import { fluidType } from 'Shared/common/FluidType'; 


const contentStyle = () => css({
	backgroundColor: borderBackgroundColour
});

const contentBlockStyle = () => css({
	backgroundColor: 'white', 
	margin: '0 auto',
	maxWidth: maxBodyWidth,
	minHeight: `calc(100vh - ${navHeight})`,
	paddingTop: '2em',
	paddingLeft: fluidType('px',sizes.mobile-100, sizes.mobile,8,32),
	paddingRight: fluidType('px',sizes.mobile-100, sizes.mobile,8,32),

	//Doesnt work with status bar
	//paddingBottom: '1em',
});


export function BackendWrap(props)
{
	return (
		<div class={contentStyle()}>
			{/*XXX {props.backend.navTemplate} */}
			<Nav settings={usePage().data.venue.settings}/>

			<div class={contentBlockStyle()}>
				{props.children}
			</div>
		</div>
	);
}

